var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6", md: "2" } },
            [
              _c("v-chip", { staticClass: "ma-2", attrs: { label: "" } }, [
                _vm._v("Subtotali Altre Componenti"),
              ]),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6", md: "1" } },
            [
              _c("v-text-field", {
                attrs: { label: "Importo Offerta", readonly: "", prefix: "€" },
                model: {
                  value: _vm.subImportoOffertaComponenti,
                  callback: function ($$v) {
                    _vm.subImportoOffertaComponenti = $$v
                  },
                  expression: "subImportoOffertaComponenti",
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6", md: "1" } },
            [
              _c("v-text-field", {
                attrs: { label: "Costo Atteso", readonly: "", prefix: "€" },
                model: {
                  value: _vm.subCostoAttesoComponenti,
                  callback: function ($$v) {
                    _vm.subCostoAttesoComponenti = $$v
                  },
                  expression: "subCostoAttesoComponenti",
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6", md: "1" } },
            [
              _c("v-text-field", {
                attrs: { label: "Margine Atteso", readonly: "", prefix: "€" },
                model: {
                  value: _vm.subMargineAttesoComponenti,
                  callback: function ($$v) {
                    _vm.subMargineAttesoComponenti = $$v
                  },
                  expression: "subMargineAttesoComponenti",
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "6", md: "1" } },
            [
              _c("v-text-field", {
                attrs: { label: "Margine Atteso %", readonly: "", prefix: "%" },
                model: {
                  value: _vm.subMargineAttesoPercComponenti,
                  callback: function ($$v) {
                    _vm.subMargineAttesoPercComponenti = $$v
                  },
                  expression: "subMargineAttesoPercComponenti",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }